// extracted by mini-css-extract-plugin
export var actionButton = "_f9-0";
export var fileInput = "_f9-2";
export var paperclip = "_f9-1";